export const isSafari = () => /^((?!chrome|android|CriOS).)*safari/i.test(navigator.userAgent)
